type Labels = {
  org: string;
  course: string;
  pathway: string;
  step: string;
};

type Catalog = {
  shortCode?: string;
};

type Contact = {
  phone?: string;
  email?: string;
  feedback?: boolean;
};

type WhiteLabel = {
  name: string;
  url: string;
  logoSrc: string;
  logoSmSrc: string;
  labels: Labels;
  catalog?: Catalog;
  contact?: Contact;
};

const BaseWhiteLabel: WhiteLabel = {
  name: 'Ministry Grid',
  url: 'ministrygrid.com',
  logoSrc: '/img/mgpro_logo_alt.svg',
  logoSmSrc: '/img/mgpro_logo_sm.svg',
  labels: {
    org: 'church',
    course: 'course',
    pathway: 'pathway',
    step: 'step',
  },
  catalog: {
    shortCode: 'MG',
  },
  contact: {
    phone: '866-627-8553',
    email: 'ministrygrid@lifeway.com',
    feedback: false,
  },
};

export const whiteLabels: { [key: string]: WhiteLabel } = {
  GRID: { ...BaseWhiteLabel },
  CONNEXUS: {
    ...BaseWhiteLabel,
    name: 'Connexus Church Training',
    url: 'training.connexuschurch.com',
    logoSrc: '/img/connexus_logo_color.png',
    catalog: {
      shortCode: 'CX',
    },
    contact: {
      email: 'jhood@connexuschurch.com',
      feedback: true,
    },
  },
  CENTRIKID: {
    ...BaseWhiteLabel,
    name: 'CentriKid Training Online',
    url: 'training.centrikid.lifeway.com',
    logoSrc: '/img/centrikid_logo.svg',
    catalog: {
      shortCode: 'CK',
    },
    contact: {
      email: 'centrikid@lifeway.com',
    },
  },
  FUGE: {
    ...BaseWhiteLabel,
    name: 'FUGE Training Online',
    url: 'training.fuge.lifeway.com',
    logoSrc: '/img/fuge_logo_color.png',
    catalog: {
      shortCode: 'FUGE',
    },
    contact: {
      email: 'fuge@lifeway.com',
    },
  },
  STUDENTLIFE: {
    ...BaseWhiteLabel,
    name: 'Student Life Camp Training Online',
    url: 'training.studentlife.lifeway.com',
    logoSrc: '/img/studentlife_logo.png',
    catalog: {
      shortCode: 'SL',
    },
    contact: {
      email: 'Rebekah@studentlife.com',
    },
  },
  SBC: {
    ...BaseWhiteLabel,
    name: 'SBC Training & Orientation Portal',
    url: 'training.sbc.net',
    logoSrc: '/img/sbc_ec_logo.png',
    logoSmSrc: '/img/sbc_logo_sm.png',
    catalog: {
      shortCode: 'SBC',
    },
    contact: {
      email: 'info@sbc.net',
    },
  },
};

export const getWhiteLabel = (key: keyof typeof whiteLabels): WhiteLabel => {
  const whiteLabel = whiteLabels[key];
  if (!whiteLabel) {
    throw new Error(`WhiteLabel with key ${key} not found`);
  }
  return whiteLabel;
};

class WhiteLabelClass {
  private whiteLabel: WhiteLabel;

  constructor(key: keyof typeof whiteLabels) {
    this.whiteLabel = getWhiteLabel(key);
  }

  setWhiteLabel(key: keyof typeof whiteLabels) {
    this.whiteLabel = getWhiteLabel(key);
  }

  isGrid() {
    return this.whiteLabel.name === whiteLabels.GRID.name;
  }

  get name() {
    return this.whiteLabel.name;
  }
  get url() {
    return this.whiteLabel.url;
  }
  get logoSrc() {
    return this.whiteLabel.logoSrc;
  }
  get logoSmSrc() {
    return this.whiteLabel.logoSmSrc;
  }
  get labels() {
    return this.whiteLabel.labels;
  }
  get catalog() {
    return this.whiteLabel.catalog;
  }
  get contact() {
    return this.whiteLabel.contact;
  }
}

const WhiteLabel = new WhiteLabelClass(window.getOrigin ? window.getOrigin() : 'GRID');
export default WhiteLabel;
